/**
 * React Query hooks for Clause Library in Word Add-in.
 */

import { useQuery } from '@tanstack/react-query'
import { listClauses, suggestClauses } from '../services/clausesApi'
import type { Clause, ClauseListParams } from '../services/clausesApi'

export const clauseKeys = {
  all: ['clauses'] as const,
  list: (params?: ClauseListParams) => ['clauses', 'list', params] as const,
  suggest: (params?: Record<string, unknown>) => ['clauses', 'suggest', params] as const,
}

export function useClauseList(params?: ClauseListParams) {
  return useQuery<Clause[]>({
    queryKey: clauseKeys.list(params),
    queryFn: () => listClauses(params),
  })
}

export function useSuggestClauses(params?: {
  category?: string
  language?: string
  limit?: number
}) {
  return useQuery<Clause[]>({
    queryKey: clauseKeys.suggest(params),
    queryFn: () => suggestClauses(params as Parameters<typeof suggestClauses>[0]),
    enabled: params != null,
  })
}
